// typeahead.js (Twitter/Algolia) — jQuery plugin + Bloodhound suggestion engine.
// The bundle export is Bloodhound; typeahead attaches itself to $.fn.typeahead.
import Bloodhound from 'typeahead.js';

export { Bloodhound };
